import styled, { css } from 'styled-components';
import { inject } from 'mobx-react';
import chroma from 'chroma-js';

const animatedBackground = css`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${({ bankAccount }) => {
    const color = chroma(bankAccount.institution_color) || lightGrey1Color;
    return `linear-gradient(to right, ${color.brighten(1)} 8%, ${color} 18%, ${color.brighten(1)} 33%)`;
  }};
  background-size: 1000px 104px;
`;

const colorStyle = css`
  background: ${({ bankAccount }) => bankAccount.institution_color};
  color: white;
  padding: ${({ editor }) => (editor ? '0 0 0 1rem' : '1rem')};
  border-radius: 0 0.25rem 0.25rem 0;
  border-left: ${({ bankAccount }) => {
    const color = chroma(bankAccount.institution_color);
    return `1px solid ${color.darken()}`;
  }};
`;

export default inject('bankAccount')(styled.div`
  display: grid;
  position: relative;
  grid-row-gap: 0.5rem;
  ${({ bankAccount }) => bankAccount.institution_color && colorStyle}
  grid-template-columns: ${({ editor }) => (editor ? '1fr 2.5rem' : 'auto')}
  ${({ isBusy }) => isBusy && animatedBackground}
`);
